import axios from "axios";
import { useState } from "react";
import { useHistory } from "react-router";
import { baseUrl, mainBaseUrl } from "../../../App";
import "./AddTemplate.scss";
import CertificateVer from "./CertificateVer";
import FormInput from "./FormInput";
const AddTemplatePage = () => {
  const [certificateImage, setcertificateImage] = useState();
  const [TemplateName, setTemplateName] = useState("");
  const [loading, setLoading] = useState(false);

  const history = useHistory();

  const addMetaData = (templateID) => {
    var data = JSON.stringify({
      templateName: TemplateName,
      coordinates: {
        userName: {
          x: x.xName,
          y: y.yName,
        },
        content: {
          x: x.xContent,
          y: y.yContent,
        },
        leadName: {
          x: x.xLeadName,
          y: y.yLeadName,
        },
        certificateId: {
          x: x.xCid,
          y: y.yCid,
        },
        issuedDate: {
          x: x.xDate,
          y: y.yDate,
        },
        verificationUrl: {
          x: x.xVerificationUrl,
          y: y.yVerificationUrl,
        },
      },
      certificateTemplateImageId: templateID,
    });

    var config = {
      method: "post",
      url: `${mainBaseUrl}/certificate/template`,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "API-Key": baseUrl,
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        setLoading(false);
        alert("Template Added Successfully");
        history.push("/certificateTemplate");
      })
      .catch(function (error) {
        setLoading(false);
        alert("There's some problem while adding the template");
        console.log(error.response);
      });
  };

  const sendData = () => {
    setLoading(true);
    var formData = new FormData();
    formData.append("certificateTemplateImage", certificateImage);
    axios
      .post(`${mainBaseUrl}/certificate/uploadTemplateImage`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          // "Content-Type": "multipart/form-data",
          "API-Key": baseUrl,
        },
      })
      .then((res) => {
        // setTemplateID(res.data.id);
        addMetaData(res.data.id);
        console.log(res.data.id);
      })
      .catch((e) => {
        setLoading(false);
        alert("There's some problem while uploading the template");
        alert(JSON.stringify(e.response.data));
      });
  };

  const setTemplate = () => {
    if (TemplateName === "") {
      alert("Please Enter Template Name");
    } else if (certificateImage.size > 400000) {
      alert("Please Upload Image less than 400 KB");
    } else {
      sendData();
    }
  };

  const [x, setx] = useState({
    xName: 270,
    xContent: 270,
    xDate: 843,
    xCid: 843,
    xLeadName: 360,
    // xTypeCode: 330,
    xVerificationUrl: 842,
  });

  const [y, sety] = useState({
    yName: 310,
    yContent: 380,
    yDate: 630,
    yCid: 611,
    yLeadName: 610,
    // yTypeCode: 220,
    yVerificationUrl: 647,
  });

  const upArrow = (codeName) => {
    switch (codeName) {
      case "name":
        sety({ ...y, yName: y.yName - 10 });
        break;
      case "desc":
        sety({ ...y, yContent: y.yContent - 10 });
        break;
      case "cid":
        sety({ ...y, yCid: y.yCid - 10 });
        break;
      case "date":
        sety({ ...y, yDate: y.yDate - 10 });
        break;
      case "lead":
        sety({ ...y, yLeadName: y.yLeadName - 10 });
        break;
      // case "type":
      //   sety({ ...y, yTypeCode: y.yTypeCode - 10 });
      // break;
      case "url":
        sety({ ...y, yVerificationUrl: y.yVerificationUrl - 10 });
        break;
      default:
    }
  };
  const downArrow = (codeName) => {
    switch (codeName) {
      case "name":
        sety({ ...y, yName: eval(y.yName) + 10 });
        break;
      case "desc":
        sety({ ...y, yContent: eval(y.yContent) + 10 });
        break;
      case "cid":
        sety({ ...y, yCid: eval(y.yCid) + 10 });
        break;
      case "date":
        sety({ ...y, yDate: eval(y.yDate) + 10 });
        break;
      case "lead":
        sety({ ...y, yLeadName: eval(y.yLeadName) + 10 });
        break;
      // case "type":
      //   sety({ ...y, yTypeCode: eval(y.yTypeCode) + 10 });
      //   break;
      case "url":
        sety({ ...y, yVerificationUrl: eval(y.yVerificationUrl) + 10 });
        break;
      default:
    }
  };

  const rightArrow = (codeName) => {
    switch (codeName) {
      case "name":
        setx({ ...x, xName: eval(x.xName) + 10 });
        break;
      case "desc":
        setx({ ...x, xContent: eval(x.xContent) + 10 });
        break;
      case "cid":
        setx({ ...x, xCid: eval(x.xCid) + 10 });
        break;
      case "date":
        setx({ ...x, xDate: eval(x.xDate) + 10 });
        break;
      // case "type":
      //   setx({ ...x, xTypeCode: eval(x.xTypeCode) + 10 });
      //   break;
      case "lead":
        setx({ ...x, xLeadName: eval(x.xLeadName) + 10 });
        break;
      case "url":
        setx({ ...x, xVerificationUrl: eval(x.xVerificationUrl) + 10 });
        break;
      default:
      // code block
    }
  };

  const leftArrow = (codeName) => {
    switch (codeName) {
      case "name":
        setx({ ...x, xName: x.xName - 10 });
        break;
      case "desc":
        setx({ ...x, xContent: x.xContent - 10 });
        break;
      case "cid":
        setx({ ...x, xCid: x.xCid - 10 });
        break;
      case "date":
        setx({ ...x, xDate: x.xDate - 10 });
        break;
      // case "type":
      //   setx({ ...x, xTypeCode: x.xTypeCode - 10 });
      //   break;
      case "lead":
        setx({ ...x, xLeadName: x.xLeadName - 10 });
        break;
      case "url":
        setx({ ...x, xVerificationUrl: x.xVerificationUrl - 10 });
        break;
    }
  };

  return (
    <div className="addTempComponent">
      <div className="settingsPannel">
        <input
          type="file"
          name="get-certificate-image"
          onChange={(e) => setcertificateImage(e.target.files[0])}
        />
        {/* <button onClick={exportPdf}>Download</button> */}
        {certificateImage == undefined ? (
          ""
        ) : (
          <CertificateVer x={x} y={y} imagePath={certificateImage} />
        )}

        <FormInput
          x={x.xName}
          y={y.yName}
          onChangex={(e) => {
            setx({ ...x, xName: Number(e.target.value) });
            console.log(e.target.value);
          }}
          onChangey={(e) => {
            sety({ ...y, yName: Number(e.target.value) });
            console.log(e.target.value);
          }}
          funUp={() => upArrow("name")}
          funDown={() => downArrow("name")}
          funLeft={() => leftArrow("name")}
          funRight={() => rightArrow("name")}
          heading="Name"
        />
        <FormInput
          x={x.xContent}
          y={y.yContent}
          onChangex={(e) => {
            setx({ ...x, xContent: Number(e.target.value) });
          }}
          onChangey={(e) => {
            sety({ ...y, yContent: Number(e.target.value) });
          }}
          funUp={() => upArrow("desc")}
          funDown={() => downArrow("desc")}
          funLeft={() => leftArrow("desc")}
          funRight={() => rightArrow("desc")}
          heading="Content"
        />
        <FormInput
          x={x.xDate}
          y={y.yDate}
          onChangex={(e) => {
            setx({ ...x, xDate: Number(e.target.value) });
          }}
          onChangey={(e) => {
            sety({ ...y, yDate: Number(e.target.value) });
          }}
          funUp={() => upArrow("date")}
          funDown={() => downArrow("date")}
          funLeft={() => leftArrow("date")}
          funRight={() => rightArrow("date")}
          heading="Date"
        />
        <FormInput
          x={x.xCid}
          y={y.yCid}
          onChangex={(e) => {
            setx({ ...x, xCid: Number(e.target.value) });
          }}
          onChangey={(e) => {
            sety({ ...y, yCid: Number(e.target.value) });
          }}
          funUp={() => upArrow("cid")}
          funDown={() => downArrow("cid")}
          funLeft={() => leftArrow("cid")}
          funRight={() => rightArrow("cid")}
          heading="Certificate ID"
        />
        <FormInput
          x={x.xLeadName}
          y={y.yLeadName}
          onChangex={(e) => {
            setx({ ...x, xLeadName: Number(e.target.value) });
          }}
          onChangey={(e) => {
            sety({ ...y, yLeadName: Number(e.target.value) });
          }}
          funUp={() => upArrow("lead")}
          funDown={() => downArrow("lead")}
          funLeft={() => leftArrow("lead")}
          funRight={() => rightArrow("lead")}
          heading="Lead Name"
        />
        {/* <FormInput
          x={x.xTypeCode}
          y={y.yTypeCode}
          onChangex={(e) => {
            setx({ ...x, xTypeCode: e.target.value });
          }}
          onChangey={(e) => {
            sety({ ...y, yTypeCode: e.target.value });
          }}
          funUp={() => upArrow("type")}
          funDown={() => downArrow("type")}
          funLeft={() => leftArrow("type")}
          funRight={() => rightArrow("type")}
          heading="Type"
        /> */}
        <FormInput
          x={x.xVerificationUrl}
          y={y.yVerificationUrl}
          onChangex={(e) => {
            setx({ ...x, xVerificationUrl: Number(e.target.value) });
          }}
          onChangey={(e) => {
            sety({ ...y, yVerificationUrl: Number(e.target.value) });
          }}
          funUp={() => upArrow("url")}
          funDown={() => downArrow("url")}
          funLeft={() => leftArrow("url")}
          funRight={() => rightArrow("url")}
          heading="URL"
        />
        {certificateImage == undefined ? (
          ""
        ) : (
          <div
            className="addCertificateData"
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "10px",
              alignItems: "start",
            }}
          >
            <input
              type="text"
              style={{ padding: "5px" }}
              placeholder="Add Template Name"
              onChange={(e) => setTemplateName(e.target.value)}
            />
            <button
              onClick={() => {
                setTemplate();
              }}
            >
              Add Template{" "}
            </button>
          </div>
        )}
      </div>
      <div className="certificatePannel">
        <div className="certificateContent" id="certificateContainerMain">
          {loading ? (
            <div
              className="centerTitile"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <h1>Uploading...</h1>
            </div>
          ) : certificateImage === undefined ? (
            <div
              className="centerTitile"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                width: "100%",
              }}
            >
              <h1>NO IMAGE</h1>
            </div>
          ) : (
            <div className="mainContentContainer">
              <p
                className={"contentWritup"}
                style={{
                  position: "absolute",
                  left: `${x.xName}px`,
                  top: `${y.yName}px`,
                }}
              >
                <i
                  style={{
                    fontFamily: "serif",
                    fontSize: "30px",
                  }}
                >
                  Aniket Singh
                </i>
              </p>

              <p
                style={{
                  position: "absolute",
                  left: `${x.xContent}px`,
                  top: `${y.yContent}px`,
                  width: "500px",
                  fontFamily: "Helvetica",
                  fontFamily: "sans-serif",
                }}
              >
                Lorem ipsum dolor sit amet consectetur, adipisicing elit. Saepe
                quaerat nesciunt consectetur reiciendis perferendis consequuntur
                aspernatur aliquid animi omnis blanditiis?
              </p>
              <p
                className={"contentWritup"}
                style={{
                  fontSize: "12px",
                  fontFamily: "Helvetica",
                  position: "absolute",
                  left: `${x.xCid}px`,
                  top: `${y.yCid}px`,
                }}
              >
                <i>123456789</i>
              </p>
              <p
                className={"contentWritup"}
                style={{
                  fontSize: "12px",
                  position: "absolute",
                  left: `${x.xDate}px`,
                  top: `${y.yDate}px`,
                  fontFamily: "Helvetica",
                }}
              >
                <i>12/11/2021</i>
              </p>
              <p
                className={"contentWritup"}
                style={{
                  fontWeight: "bold",
                  position: "absolute",
                  left: `${x.xLeadName}px`,
                  top: `${y.yLeadName}px`,
                }}
              >
                <i
                  style={{
                    fontFamily: "serif",
                  }}
                >
                  Roshan Paturkar
                </i>
              </p>
              <p
                className={"contentWritup"}
                style={{
                  position: "absolute",
                  left: `${x.xVerificationUrl}px`,
                  top: `${y.yVerificationUrl}px`,
                }}
              >
                <a
                  style={{
                    fontSize: "12px",
                    color: "black",
                    textDecoration: "none",
                    fontFamily: "Helvetica",
                  }}
                  href="https://www.google.co.in/"
                >
                  <i>https://www.google.co.in/</i>
                </a>
              </p>
              <img
                className="rawCertificate"
                src={URL.createObjectURL(certificateImage)}
                alt="certificate"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddTemplatePage;
